<div
  #opacRadioElement="opacRadioElement"
  [opacRadioElement]="name"
  [disabled]="disabled"
  [checked]="checked"
  [value]="value"
>
  <div class="radio-box">
    <div></div>
    <opac-icon icon="radio_button_dot"></opac-icon>
  </div>

  <span>
    <ng-content></ng-content>
  </span>
</div>
